import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas do módulo de reencontro (P5).
 *
 * ⚠️ **As duas exigem sessão, e por motivos diferentes.**
 *
 * `reunionRoutes` (`/reunion`) entra **dentro do `AppLayout`, sob o
 * `RequireSession`** — o mesmo ramo de `/calls` e `/notes`. Não é preferência de
 * navegação: a DV-08 decidiu que busca de abrigados e lista de desaparecidos são
 * só para quem tem conta, e a RLS devolve zero linha para `anon`. Montada sem
 * guard, a tela seria uma busca que nunca encontra ninguém.
 *
 * `reunionProtectedRoutes` (`/institutions/:id/sheltered`) entra no ramo
 * protegido que monta **fora** do `AppLayout`, junto de
 * `institutionsProtectedRoutes` e `donationsProtectedRoutes`: é fluxo de tarefa
 * com formulário, e um toque acidental numa aba no meio dele descarta o
 * trabalho. A tela ainda checa o papel de admin — o guard só garante sessão.
 */
const ReunionPage = lazy(() => import('./routes/Reunion.page'));
const InstitutionShelteredPage = lazy(() => import('./routes/InstitutionSheltered.page'));

export const reunionRoutes: RouteObject[] = [{ path: 'reunion', element: <ReunionPage /> }];

export const reunionProtectedRoutes: RouteObject[] = [
  { path: 'institutions/:id/sheltered', element: <InstitutionShelteredPage /> },
];
